import axios from 'axios';
import {
  GET_MAP_PLATES_REQUEST,
  DELETE_MAP_PLATE_REQUEST,
  GET_PLATE_SUGGESTIONS_REQUEST,
  CREATE_MAP_PLATE_REQUEST,
} from 'redux/actions';

import { call, put, takeLatest, delay } from 'redux-saga/effects';

import {
  getMapPlatesSuccess,
  getMapPlatesError,
  deleteMapPlateSuccess,
  deleteMapPlateError,
  createMapPlateSuccess,
  createMapPlateError,
  getPlateSuggestionsSuccess,
  getPlateSuggestionsError,
  getMapPlatesProgress,
} from './actions';

const getMapPlatesAsync = async (page = 1, filters = {}) => {
  const queryParams = new URLSearchParams({
    page,
    perpage: 50,
    ...filters,
  });

  const response = await axios.get(`/mukeb/map/plate/plates?${queryParams}`);

  return response.data;
};

function* getMapPlates(action) {
  try {
    const { filters } = action.payload;

    let page = 1;
    let allPlates = [];
    let meta = null;

    while (true) {
      const response = yield call(getMapPlatesAsync, page, filters);

      const data = response.plates.data;
      meta = response.plates.meta;

      allPlates = [...allPlates, ...data];

      const lastPage = meta?.last_page || 1;

      const progress = Math.round((page / lastPage) * 100);

      yield put(getMapPlatesProgress(progress));

      if (!meta || page >= lastPage) break;

      page++;
      // yield delay(1000);
    }

    yield put(getMapPlatesSuccess(allPlates, meta, null, true));
    yield put(getMapPlatesProgress(100));
  } catch (error) {
    yield put(getMapPlatesError(error.message));
  }
}

const getPlateSuggestionsAsync = async () => {
  const response = await axios.get('/mukeb/map/plate/suggestions');

  return response.data;
};

function* getPlateSuggestions() {
  try {
    const { plates } = yield call(getPlateSuggestionsAsync);

    yield put(getPlateSuggestionsSuccess(plates));
  } catch (error) {
    yield put(getPlateSuggestionsError(error.message));
  }
}

const createMapPlateAsync = async (data) => {
  const formData = new FormData();

  formData.append('plate_id', data.plate_id);
  formData.append('lat', data.lat);
  formData.append('lng', data.lng);

  const response = await axios.post('/mukeb/map/plate/plates', formData);

  return response.data;
};

function* createMapPlate(action) {
  try {
    const response = yield call(createMapPlateAsync, action.payload);

    const { plate, success } = response;

    yield put(createMapPlateSuccess(plate, success));
  } catch (error) {
    yield put(createMapPlateError(error.message));
  }
}

const deleteMapPlateAsync = async (id) => {
  const response = await axios.delete(`/mukeb/map/plate/plates/${id}`);

  return response.data;
};

function* deleteMapPlate(action) {
  try {
    const { id } = action.payload;

    const { success, messages } = yield call(deleteMapPlateAsync, id);

    yield put(deleteMapPlateSuccess(id, success, messages));
  } catch (error) {
    yield put(deleteMapPlateError(error.message));
  }
}

export default function* rootSaga() {
  yield takeLatest(GET_MAP_PLATES_REQUEST, getMapPlates);
  yield takeLatest(GET_PLATE_SUGGESTIONS_REQUEST, getPlateSuggestions);
  yield takeLatest(CREATE_MAP_PLATE_REQUEST, createMapPlate);
  yield takeLatest(DELETE_MAP_PLATE_REQUEST, deleteMapPlate);
}
